import { useMemo } from 'react';
import { QBox, QMenuButton } from '@qualio/ui-components';
import * as DisplayStrings from '../../../../../displayStrings';
import { sortAlphabeticallyByProperty } from '../../../../../utils/arrayUtils';
import { ArrayElement } from '../../../../../utils/typeUtils';
import { FieldTypeSchema } from '../../../../../types/formFields/common';
import { mapRegistryFieldToButton, mapStaticObjectFieldToButton } from '../shared';
import { RegistryCategory } from '../../../../../types/registry';
import { AddField } from '../../../shared';

type QObjectFieldProps = {
  addField: AddField;
  registryCategories: RegistryCategory[];
};

const MenuOptions = [
  FieldTypeSchema.enum.document,
  FieldTypeSchema.enum.supplier,
  FieldTypeSchema.enum.event,
  FieldTypeSchema.enum.user,
  FieldTypeSchema.enum.change_request,
  FieldTypeSchema.enum.training_plan,
  FieldTypeSchema.enum.document_template,
  FieldTypeSchema.enum.event_template,
  FieldTypeSchema.enum.task,
];

const QObjectField = ({ addField, registryCategories }: QObjectFieldProps) => {
  const buttonOptions = useMemo(() => {
    const staticFieldButtons = MenuOptions.map(mapStaticObjectFieldToButton);
    const registryFieldButtons = registryCategories.map(mapRegistryFieldToButton);
    const designControlsFieldButtons = [FieldTypeSchema.enum.design_controls].map(mapStaticObjectFieldToButton);
    return sortAlphabeticallyByProperty(
      [...staticFieldButtons, ...registryFieldButtons, ...designControlsFieldButtons],
      'label',
    );
  }, [registryCategories]);

  return (
    <QBox data-cy={'add-q-object-field-menu'}>
      <QMenuButton
        buttonLabel={DisplayStrings.ChooseQualioResource}
        itemSize="sm"
        items={buttonOptions}
        onItemClick={(event) => {
          if (
            MenuOptions.includes(event.id as ArrayElement<typeof MenuOptions>) ||
            event.id === FieldTypeSchema.enum.design_controls
          ) {
            addField(event.id as ArrayElement<typeof MenuOptions>);
          } else {
            addField('registry', event.id.split(':')[1]);
          }
        }}
        variant="outline"
        maxHeight={400}
        maxWidth="350px"
      />
    </QBox>
  );
};

export default QObjectField;
